module.exports = __webpack_public_path__ + "img/icon-differentials2_03.2026e49b.svg";